import { Link } from '@mna/react'
import i18next from 'i18next';
import React from "react";

const HeaderTitle = ({
  menuTitle, menuCenter,
  isHeaderMenuOpen,
  closeHeaderMenu,
  toggleHeaderMenu
}) =>
  <div className="header-title" style={{ zIndex: 1 }}>
    <div className="header-title-content">
      <div className="header-title-content-left"
        onClick={()=>{}}
      >
        {menuTitle}
      </div>
      { !menuCenter ? null
        :
        <div className="header-center md-hide">{menuCenter}</div>
      }

      <div className={`header-title-content-right md-hide`} tabIndex="0" 
        role="button"
        onClick={toggleHeaderMenu} 
        onKeyDown = {(e)=>{
            if(e.key === " " || e.key === "Enter"){
              toggleHeaderMenu(e);
             //console.log(e.key,"key press")
            }
        }}
        onFocus={()=>{
          var hamburgerValue = document.getElementById("hamburger");
          if(hamburgerValue && hamburgerValue.getAttribute("aria-expanded") !== 'true'){
            var hamburgerEl = document.getElementById("hamburger");
            if (hamburgerEl) hamburgerEl.setAttribute('aria-label', i18next.t('Hamburger.hamburgerExp'));
            if (hamburgerEl) hamburgerEl.removeAttribute('aria-expanded');  
          }
        }}
        aria-controls="dvMenuList"
        id="hamburger" aria-expanded="false"
        aria-label={i18next.t("Hamburger.hamburgerExp")}
      >
        <div className={`hamburger${isHeaderMenuOpen ? ' is-open' : ''}`} >
          <span id="hamburgerOption" aria-label={i18next.t("Hamburger.hamburgerExp")}></span>
        </div>
      </div>
    </div>
  </div>

const MenuItem = ({ item }) =>
  item.to
    ? <Link to={item.to} exact={
      // exact=true by default
      typeof item.exact==='undefined' ? true
        : item.exact
    }>{item.content}</Link>
    : (item.content || item)

const MenuItems = ({ items, keyPrefix = '' }) =>
  <>
    {items.map((item, itemIndex) =>
       <li key={
        (keyPrefix ? `${keyPrefix}-` : '')+itemIndex
      } className="header-menu-item">
        <MenuItem item={ item } />
        { !item.children || item.children.length === 0 ? null :
          <ul className="list-reset">
            <MenuItems items={item.children}
              keyPrefix={(keyPrefix ? `${keyPrefix}-` : '')+itemIndex}
            />
          </ul>
        }
      </li>
    )}
  </>

const HeaderMenu = ({
  closeHeaderMenu,
  menuItems: items
}) =>
  <div className={`header-menu`}>
    <div className="header-menu-content headerMenu">
      <ul className="list-reset" id="dvMenuList">
        <MenuItems items={items} />
      </ul>
    </div>
  </div>

const Header = ({ isHeaderMenuOpen, closeHeaderMenu, toggleHeaderMenu, menuTitle, menuItems, menuCenter }) =>
  <header className={`site-header`}>
    <HeaderTitle {...{
      menuTitle, menuCenter,
      isHeaderMenuOpen,
      closeHeaderMenu,
      toggleHeaderMenu
    }}/>
    { !menuCenter ? null
      :
      <div className="header-center md-show">{menuCenter}</div>
    }
    <HeaderMenu {...{
      menuItems,
      closeHeaderMenu
    }}/>
  </header>

export default Header
